import React from 'react';
import { View, Text, StyleSheet, Linking } from 'react-native';
import { Button } from 'react-native-elements';

import { deviceWidth } from '../helpers/deviceHelper';
import { dateElementsExtractor } from '../helpers/dateHelper';

import MaskedImageContainer from '../components/MaskedImageContainer';

const styles = StyleSheet.create({
  container: {
    // backgroundColor: '#f3f4f4',
    backgroundColor: 'white',
    alignItems: 'center',
  },
  infoContainer: {
    // borderColor: 'red',
    // borderWidth: 3,
    padding: deviceWidth * 0.05,
  },

  title: {
    // fontFamily: 'MPLUS1p_100Thin',
    // fontFamily: 'MPLUS1p_300Light',
    // fontFamily: 'MPLUS1p_400Regular',
    // fontFamily: 'MPLUS1p_500Medium',
    fontFamily: 'MPLUS1p_700Bold',
    // fontFamily: 'MPLUS1p_800ExtraBold',
    // fontFamily: 'MPLUS1p_900Black
    fontSize: 24,
    fontWeight: 'bold',
  },

  description: {
    fontFamily: 'MPLUS1p_100Thin',
    // fontFamily: 'MPLUS1p_300Light',
    // fontFamily: 'MPLUS1p_400Regular',
    // fontFamily: 'MPLUS1p_500Medium',
    // fontFamily: 'MPLUS1p_700Bold',
    // fontFamily: 'MPLUS1p_800ExtraBold',
    // fontFamily: 'MPLUS1p_900Black
    fontSize: 20,
    marginBottom: deviceWidth * 0.05,
  },

  date: {
    // fontFamily: 'MPLUS1p_100Thin',
    // fontFamily: 'MPLUS1p_300Light',
    // fontFamily: 'MPLUS1p_400Regular',
    fontFamily: 'MPLUS1p_500Medium',
    // fontFamily: 'MPLUS1p_700Bold',
    // fontFamily: 'MPLUS1p_800ExtraBold',
    // fontFamily: 'MPLUS1p_900Black
    fontSize: 20,
  },

  time: {
    fontFamily: 'MPLUS1p_100Thin',
    // fontFamily: 'MPLUS1p_300Light',
    // fontFamily: 'MPLUS1p_400Regular',
    // fontFamily: 'MPLUS1p_500Medium',
    // fontFamily: 'MPLUS1p_700Bold',
    // fontFamily: 'MPLUS1p_800ExtraBold',
    // fontFamily: 'MPLUS1p_900Black

    // fontStyle: 'italic',
    // fontWeight: 'bold',
    fontSize: 20,
    marginBottom: deviceWidth * 0.05,
  },
  venue: {
    // fontFamily: 'MPLUS1p_100Thin',
    // fontFamily: 'MPLUS1p_300Light',
    fontFamily: 'MPLUS1p_400Regular',
    // fontFamily: 'MPLUS1p_500Medium',
    // fontFamily: 'MPLUS1p_700Bold',
    // fontFamily: 'MPLUS1p_800ExtraBold',
    // fontFamily: 'MPLUS1p_900Black
    fontSize: 20,
    marginBottom: deviceWidth * 0.05,
  },

  price: {
    // fontFamily: 'MPLUS1p_100Thin',
    // fontFamily: 'MPLUS1p_300Light',
    fontFamily: 'MPLUS1p_400Regular',
    // fontFamily: 'MPLUS1p_500Medium',
    // fontFamily: 'MPLUS1p_700Bold',
    // fontFamily: 'MPLUS1p_800ExtraBold',
    // fontFamily: 'MPLUS1p_900Black
    fontSize: 20,
    marginBottom: deviceWidth * 0.05,
  },

  button: { width: deviceWidth * 0.9, marginBottom: 20 },
  bookingSection: {
    // borderColor: 'red',
    // borderWidth: 3,
    alignSelf: 'stretch',
    padding: deviceWidth * 0.05,
    marginBottom: deviceWidth * 0.05,
  },

  bookingEnd: {
    fontFamily: 'MPLUS1p_300Light',
    fontSize: 20,
    color: 'red',
  },

  bookingByPhoneText: {
    fontFamily: 'MPLUS1p_300Light',
    fontSize: 20,
  },
  bookingByEmailText: {
    fontFamily: 'MPLUS1p_300Light',
    fontSize: 20,
  },
});

export default function ConcertDetailScreen({ navigation, route }) {
  const {
    imageUrl,
    title,
    date,
    time,
    venue,
    price,
    description,
    bookingFormLink,
    bookingAccept,
    bookingPhoneNumber,
    bookingEmail,
  } = route.params;

  const { year, month, day, japaneseDay } = dateElementsExtractor(
    new Date(date)
  );
  return (
    <View style={styles.container}>
      <View style={styles.infoContainer}>
        <Text style={styles.title}>{title}</Text>
        <Text style={styles.description}>
          {description ? description.replace('\\n', '\n') : ''}
        </Text>
        <Text
          style={styles.date}
        >{`${year}年${month}月${day}日(${japaneseDay})`}</Text>
        <Text style={styles.time}>{time}</Text>
        <Text style={styles.venue}>{venue}</Text>
        <Text style={styles.price}>
          {price ? price.replace('\\n', '\n') : ''}
        </Text>
      </View>
      <View style={styles.bookingSection}>
        {bookingFormLink && bookingAccept ? (
          <Button
            buttonStyle={styles.button}
            title="Web予約"
            onPress={() => {
              Linking.openURL(bookingFormLink);
            }}
          />
        ) : null}
        {bookingFormLink && !bookingAccept ? (
          <Text style={styles.bookingEnd}>
            満席につき予約の受け付けを終了致しました。
          </Text>
        ) : null}
        {bookingPhoneNumber ? (
          <View>
            <Text style={styles.bookingByPhoneText}>電話予約</Text>
            <Text style={styles.bookingByPhoneText}>{bookingPhoneNumber}</Text>
          </View>
        ) : null}
        {bookingEmail ? (
          <View>
            <Text style={styles.bookingByEmailText}>e-メール予約</Text>
            <Text style={styles.bookingByEmailText}>{bookingEmail}</Text>
          </View>
        ) : null}
      </View>
      <MaskedImageContainer
        uri={imageUrl[0]}
        imageProportionType="a4"
        imageWidthRelativeToDeviceWidth={0.9}
        maskWidthRelativeToDeviceWidth={0.9}
        verticalAlignment="top"
      />
      <MaskedImageContainer
        uri={imageUrl[1]}
        imageProportionType="a4"
        imageWidthRelativeToDeviceWidth={0.9}
        maskWidthRelativeToDeviceWidth={0.9}
        verticalAlignment="top"
      />
    </View>
  );
}
